module.exports = __webpack_public_path__ + "media/badges/discount-percentage-badge-33dddfd5.svg";